import { Pen, PencilLine, User } from "lucide-react";
import React from "react";

function MyCard4({ className = "", onClick, icon, title, color, value ,onEdit }) {
  const Icon = icon || User;
  return (
    <div
      onClick={() => onClick && onClick()}
      className={`w-full ${className}  flex flex-row space-x-2 rounded-lg bg-gray-400/13 dark:bg-slate-800 `}
     >
      <Icon
        className={`w-8 h-8 p-2 rounded-lg  ${color.text} bg-slate-600/30 dark:bg-slate-700/90`}
      />
      <div className="flex flex-col items-start justify-center space-y-[0px]">
        <span className="text-md font-semibold text-slate-600 dark:text-slate-300">
          {value}
        </span>
        <span className="text-[10px] font-normal text-slate-600 dark:text-slate-300">
          {title}
        </span>
      </div>
      {onEdit && (
          <PencilLine
            onClick={(e) => {
              e.stopPropagation();
              if (onEdit) onEdit();
            }}
            className={`w-5 h-5 p-1 text-slate-600 dark:text-slate-200 rounded-lg ml-auto cursor-pointer`}
          />
        )}

    </div>
  );
}
export default MyCard4;
